"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeTimerType = void 0;
var NativeTimerType;
(function (NativeTimerType) {
    NativeTimerType["TIMER_1"] = "TIMER_1";
    NativeTimerType["TIMER_2"] = "TIMER_2";
    NativeTimerType["TIMER_3"] = "TIMER_3";
    NativeTimerType["TIMER_4"] = "TIMER_4";
    NativeTimerType["TIMER_5"] = "TIMER_5";
    NativeTimerType["TIMER_6"] = "TIMER_6";
    NativeTimerType["TIMER_7"] = "TIMER_7";
})(NativeTimerType || (exports.NativeTimerType = NativeTimerType = {}));
